<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import type { VuetifyRule } from "@/types/props";
import { useValidation } from "@/composables/useValidation";

const model = defineModel<string | null>({ default: null });

const { t } = useI18n();
const { emailValidator } = useValidation();

const props = withDefaults(
  defineProps<{
    rules?: VuetifyRule[];
    required?: boolean;
  }>(),
  {
    rules: () => [],
    required: true,
  },
);
</script>

<template>
  <v-text-field
    v-model="model"
    :class="{
      required: props.required,
    }"
    :label="t('general.email')"
    :rules="[...props.rules, emailValidator]"
    color="primary"
    density="compact"
    variant="outlined"
  />
</template>
